import styled, { css } from 'styled-components'

export const FormStyled = styled.form``

export const FormLine = styled.div`
  display: flex;
  gap: 12px;
`

export const InputLine = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
  width: 100%;
`

export const CheckboxWrap = styled.label`
  flex: 1 0 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--t-checkbox-wrap-text);
  border: 1px solid var(--t-surface-2);
  background-color: var(--t-surface-2);
  transition: all 0.3s;

  &:hover {
    border-color: var(--t-input-hover);
  }

  label {
    display: flex;
    justify-content: center;
  }

  div {
    position: absolute !important;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    overflow: hidden;
    white-space: nowrap;
  }

  span {
    margin-right: 0;
  }
`

export const FormButtonWrap = styled.div`
  width: 40px;
  margin-bottom: 17px;

  ${(p) =>
    p.color === 'red' &&
    css`
      button {
        color: var(--t-tags-delete-button-color);
      }
    `}

  button {
    padding: 0 20px;
    display: block;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: 0;
    transform: translate(-50%, -50%);
  }
`
export const ButtonModalWrap = styled.div`
  display: flex;
  gap: 12px;

  button {
    padding: 0 32px;
    width: auto;
  }
`
